import React from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CallFab } from "@/components/CallFab";
import { InstallBanner } from "@/components/InstallBanner";
import { RouteTracker } from "@/components/RouteTracker";

import Home from "@/pages/Home";
import ServicesPage from "@/pages/ServicesPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import BookingPage from "@/pages/BookingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import CustomerDashboard from "@/pages/CustomerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import ConfirmPage from "@/pages/ConfirmPage";
import VehicleListPage from "@/pages/VehicleListPage";
import VehicleDetailPage from "@/pages/VehicleDetailPage";
import ServiceAreaPage from "@/pages/ServiceAreaPage";
import ServiceFaqPage from "@/pages/ServiceFaqPage";
import CustomerAuthPage from "@/pages/CustomerAuthPage";
import CustomerAccountPage from "@/pages/CustomerAccountPage";
import ManageBookingPage from "@/pages/ManageBookingPage";

const MarketingLayout = () => (
  <div className="App min-h-screen flex flex-col bg-background">
    <Navbar />
    <main className="flex-1"><Outlet /></main>
    <Footer />
    <CallFab />
    <InstallBanner />
  </div>
);

const BareLayout = () => (
  <div className="App min-h-screen bg-background">
    <Navbar />
    <main><Outlet /></main>
  </div>
);

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <RouteTracker />
          <Routes>
            <Route element={<MarketingLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/services/:slug" element={<ServiceFaqPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/book" element={<BookingPage />} />
              <Route path="/cars-for-sale" element={<VehicleListPage mode="sale" />} />
              <Route path="/cars-for-rent" element={<VehicleListPage mode="rent" />} />
              <Route path="/vehicles/:id" element={<VehicleDetailPage />} />
              <Route path="/mechanic/:suburb" element={<ServiceAreaPage />} />
              <Route path="/account/login" element={<CustomerAuthPage />} />
              <Route path="/account" element={<CustomerAccountPage />} />
              <Route path="/c/:token" element={<ConfirmPage />} />
              <Route path="/booking/manage/:token" element={<ManageBookingPage />} />
            </Route>
            <Route element={<BareLayout />}>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <CustomerDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute requireAdmin>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
